var exports = {
  "qS": "GuildTagBadge.module__badge___em1QSU",
  "_y": "GuildTagBadge.module__sprite___em1QSU",
  "ip": "GuildTagBadge.module__tones___em1QSU",
};

module.exports = exports;
